import React, { ReactElement } from 'react';
import Slider from 'react-slick';
import { bannerType } from '../../../lib/types';

type bannerProps = {
    banners: bannerType[] | [],
    onBannerClick: (banner: bannerType) => void
}

const Banner = ({ banners, onBannerClick }: bannerProps): ReactElement => {
    return (
        <div className="my-4 z-0 banner-container">
            <Slider
                dots
                slidesToShow={1}
                slidesToScroll={1}
                autoplay={true}
                autoplaySpeed={5000}
                adaptiveHeight
                arrows={false}
                centerMode
                centerPadding="12px"
                pauseOnHover
                pauseOnFocus
                pauseOnDotsHover
                dotsClass="slick-dots banner-dots"
            >
                {banners.map((banner, index) => (
                    <div key={index} className="relative banner-item-container">
                        <div className="absolute rounded-xl border border-solid border-gray-300 text-center inset-0 mx-1 banner-item" onClick={() => onBannerClick(banner)}>
                            <img src={banner.src} alt={`banner ${index + 1}`} className="h-full w-full rounded-xl" />
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default Banner;
